"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import React, { useEffect, useState } from "react";

export const InfiniteMovingCards = ({
  items,
  direction = "left",
  speed = "fast",
  pauseOnHover = true,
  className,
}) => {
  const containerRef = React.useRef(null);
  const scrollerRef = React.useRef(null);
  const [start, setStart] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      getDirection();
      getSpeed();
      setStart(true);
    }
  }, []);

  const getDirection = () => {
    if (containerRef.current) {
      containerRef.current.style.setProperty(
        "--animation-direction",
        direction === "left" ? "forwards" : "reverse"
      );
    }
  };

  const getSpeed = () => {
    if (containerRef.current) {
      const duration =
        speed === "fast" ? "20s" : speed === "normal" ? "40s" : "80s";
      containerRef.current.style.setProperty("--animation-duration", duration);
    }
  };

  return (
    <div
      ref={containerRef}
      className={cn(
        "scroller relative z-20 w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,white_15%,white_85%,transparent)]",
        className
      )}
    >
      <ul
        ref={scrollerRef}
        className={cn(
          "flex w-max min-w-full shrink-0 flex-nowrap gap-6 py-4",
          start && "animate-scroll",
          pauseOnHover && "hover:[animation-play-state:paused]"
        )}
      >
        {[...items, ...items].map((item, idx) => (
          <li
            key={idx}
            className="relative w-[421px] max-w-full shrink-0 h-[277px] rounded-2xl border-[1px] border-[#ececec] bg-[rgba(244,244,244,0.3)] px-6 py-6"
          >
            <blockquote>
              <div className="flex items-center gap-4">
                <div className="relative w-18 h-18">
                <Image
                  src={item.profile}
                  alt={item.name}
                  fill
                  className="rounded-full object-cover"
                />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-neutral-800 dark:text-gray-200">
                    {item.name}
                  </span>
                  <span className="text-xs text-neutral-500 dark:text-gray-400">
                    {item.role}
                  </span>
                </div>
              </div>
              <p className="text-sm text-neutral-700 dark:text-gray-100 mt-4 leading-relaxed">
                “{item.text}”
              </p>
            </blockquote>
          </li>
        ))}
      </ul>
    </div>
  );
};
